export const defaultGameInfo = {
  user_name: '',
  user_id: '',
  currency: 'USD',
  balance: '',
  precision: 2,
  maxBet: '',
  minBet: '',
  game_settings: {
    ante: [''],
    aa: [''],
  },
  serverSeedSHA256: '',
  clientSeed: '',
  nonce: 0,
  next_server_seed_SHA256: '',
}
export const defaultStakes = {
  ante: '0',
  AAbonus: '0',
}
export const defaultAudio = {
  music: true,
  sound: true,
  volume: '0.5',
}

export const defaultStateRound = {
  aa: { bet: '0', win: '0', mult: '0' },
  ante: { bet: '0', win: '0', mult: '0' },
  balance: '',
  balancebefore: '',
  cards: (9)[('X0', 'X0', 'X0', 'X0', 'X0', 'X0', 'X0', 'X0', 'X0')],
  currentBetId: '',
  dealerWinPositions: (9)[('0', '0', '0', '0', '0', '0', '0', '0', '0')],
  dealerWinType: 0,
  playerWinPositions: (9)[('0', '0', '0', '0', '0', '0', '0', '0', '0')],
  playerWinType: 0,
  totalWin: '0',
  raise: { bet: '0', win: '0', mult: '0' },
  state: 0,
}

export const defaultSeeds = {
  client_seed: '',
  server_seed_SHA256: '',
  next_server_seed_SHA256: '',
  nonce: 0,
  old_client_seed: '',
  old_server_seed: '',
  old_server_seed_SHA256: '',
  old_nonce: 0,
}
